export const REFERRAL_CAMPAIGN_CODE = 'bowtie-friends-and-family-referral-program';